const SCHOOL_ALIASES = {
    'mountainside': 'mma',
    'mountainside music academy': 'mma',
    'lakeside': 'lsma',
    'lakeside music academy': 'lsma',
    'treeside': 'tma',
    'treeside music academy': 'tma',
    'morningside': 'mor',
    'morningside music academy': 'mor',
    'parkside': 'psma',
    'parkside music academy': 'psma',
    'denton': 'den',
    'denton music academy': 'den',
    'tempe': 'tem',
    'tempe music academy': 'tem',
    'tulsa': 'tul',
    'tulsa music academy': 'tul',
}

const UNASSIGNABLE_STATUSES = new Set(['leaving', 'left school'])

export const normalizeTeacherAssignmentSchool = (school) => {
    const normalizedSchool = String(school || '').trim().toLowerCase()
    return SCHOOL_ALIASES[normalizedSchool] || normalizedSchool
}

export const isTeacherAvailableForAssignment = (teacher) => {
    const status = String(teacher?.Status || '').trim().toLowerCase()
    return Boolean(teacher?.TeacherID) && !UNASSIGNABLE_STATUSES.has(status)
}

export const getAssignableTeachersForCard = (teachers, card) => {
    const cardSchool = normalizeTeacherAssignmentSchool(card?.whichSchool)

    if (!cardSchool || !Array.isArray(teachers)) {
        return []
    }

    return teachers
        .filter((teacher) =>
            isTeacherAvailableForAssignment(teacher)
            && normalizeTeacherAssignmentSchool(teacher?.School) === cardSchool
        )
        .sort((teacherA, teacherB) =>
            String(teacherA?.Name || '').localeCompare(
                String(teacherB?.Name || ''),
                undefined,
                { sensitivity: 'base' }
            )
        )
}

export const getAssignedTeachersForCard = (card, teachers) => {
    const savedTeachers = Array.isArray(card?.assignedTeachers)
        ? card.assignedTeachers
        : []

    return savedTeachers
        .map((savedTeacher) => {
            const assignedTeacherId = String(savedTeacher?.teacherId || '').trim()
            if (!assignedTeacherId) return null

            const currentTeacher = Array.isArray(teachers)
                ? teachers.find(
                    (teacher) =>
                        String(teacher?.TeacherID || '').trim() === assignedTeacherId
                )
                : null

            if (!currentTeacher) {
                return savedTeacher
            }

            return {
                teacherId: currentTeacher.TeacherID,
                teacherName: currentTeacher.Name,
                imageName: currentTeacher.ImageName,
                school: currentTeacher.School,
                status: currentTeacher.Status,
            }
        })
        .filter(Boolean)
}

export const resolveTeacherImageUrl = (imageName) => {
    const normalizedImageName = String(imageName || '').trim()

    if (!normalizedImageName) {
        return ''
    }

    if (/^(https?:|data:|blob:)/i.test(normalizedImageName)) {
        return normalizedImageName
    }

    return `https://app.atharo.app/images/${normalizedImageName}`
}
